export default {
    dependencies: ['$element', 'trackingservice'],
    callable(ele, trackingService) {
        ele.addEventListener('focus', () => {
            trackingService.trackEvent('a11y.skiplink.focus');
        });
        ele.addEventListener('click', () => {
            trackingService.trackEvent('a11y.skiplink.click');
        });
        /*
        This part is logging too much...
        if (window.innerWidth < window.outerWidth) {
            trackingService.trackEvent('a11y.browser-zoom.load');
        }*/
    },
};



// WEBPACK FOOTER //
// ./controllers/a11ytics.js